import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CplRequestItem } from 'src/app/model/cpl-request-item.model';
import { CplUserRequest } from 'src/app/model/cpl-user-request.model';
import { UserRequestService } from 'src/app/services/user-request.service';
import { TimeTrackingTypes } from '../../../model/enum/cpl-time-tracking-type.enum';
import { RequestHelpersService } from 'src/app/services/request-helpers/request-helpers.service';
import { UserTimeTrackingForm } from 'src/app/time-tracking/model/user-time-tracking-form/user-time-tracking-form.model';
import { UserTimeTrackingFormService } from 'src/app/time-tracking/services/user-time-tracking-form/user-time-tracking-form.service';

@Component({
    selector: 'user-request-flex-details',
    templateUrl: './user-request-flex-details.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UserRequestFlexDetailsComponent implements OnInit {
    @Input() requestItem: CplRequestItem;
    @Input() userRequest: CplUserRequest;
    @Input() isReadOnly: boolean = false;

    @Output() onSaveComplete = new EventEmitter<{ success: boolean }>();

    form: UserTimeTrackingForm;

    TimeTrackingType = TimeTrackingTypes;
    busy: boolean = false;

    constructor(
        private toastr: ToastrService,
        private userRequestService: UserRequestService,
        private requestHelpersService: RequestHelpersService,
        private userTimeTrackingFormService: UserTimeTrackingFormService
    ) { }

    ngOnInit(): void {
        this.isReadOnly = this.isReadOnly || this.isCompleted();

        this.form = this.userTimeTrackingFormService.buildForm({
            userFlexDetails: this.userRequest?.FlexDetails,
            itemFlexDetails: this.requestItem?.FlexDetails,
            isCompleted: this.isCompleted(),
            disabled: this.isReadOnly        
        });
    }

    get userName(): string {
        return `${this.userRequest.FirstName || ''} ${this.userRequest.LastName || ''}`.trim() || 'User';
    }

    get dueDateFormatted(): string {
        return 'N/A';
    }

    get itemTitle(): string {
        return this.requestItem?.Title || 'N/A';
    }

    canSave(): boolean {
        return !this.isReadOnly && !this.busy && this.form.valid;
    }

    onSave(): void {
        if (!this.canSave()) {
            return;
        }
        if (!this.requestItem?.RequestID || !this.userRequest?.UserRequestID) {
            console.error('Missing RequestID or UserRequestId for saving flex details.');
            this.onSaveComplete.emit({ success: false });
            return;
        }
        this.busy = true;

        const details = this.userTimeTrackingFormService.packageForm(this.form);

        this.userRequestService.updateFlexHoursForUserRequest(this.userRequest.UserRequestID, details)
            .subscribe({
                next: () => {
                    // Only update the model after successful save
                    if (this.userRequest.FlexDetails) {
                        this.userRequest.FlexDetails.Hours = details.Hours;
                    }

                    this.toastr.success('Flex details saved successfully.', 'Save Successful');

                    this.busy = false;
                    this.onSaveComplete.emit({ success: true });
                },
                error: (error) => {
                    // HttpErrorHandler interceptor displays the error automatically
                    this.busy = false;
                    console.error('Error saving flex details:', error);
                    this.onSaveComplete.emit({ success: false });
                }
            });
    }

    isCompleted(): boolean {
        return this.requestHelpersService.isFinalUserStatus(this.userRequest?.UserStatus)
    }
}